var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArShadesCataloguesicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    zoomAndPan: "magnify",
    viewBox: "0 0 384 383.999986",
    height: 512,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f539359b37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.640625 115.34375 L 181.570312 115.34375 L 181.570312 234.226562 L 4.640625 234.226562 Z M 4.640625 115.34375 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2e084e6123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.640625 115.34375 L 172.417969 115.34375 C 177.386719 115.34375 181.417969 119.371094 181.417969 124.34375 L 181.417969 225.226562 C 181.417969 230.195312 177.386719 234.226562 172.417969 234.226562 L 13.640625 234.226562 C 8.671875 234.226562 4.640625 230.195312 4.640625 225.226562 L 4.640625 124.34375 C 4.640625 119.371094 8.671875 115.34375 13.640625 115.34375 Z M 13.640625 115.34375 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a5eb9378c1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 202.582031 115.34375 L 379.511719 115.34375 L 379.511719 234.226562 L 202.582031 234.226562 Z M 202.582031 115.34375 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5139a81386"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211.582031 115.34375 L 370.359375 115.34375 C 375.328125 115.34375 379.359375 119.371094 379.359375 124.34375 L 379.359375 225.226562 C 379.359375 230.195312 375.328125 234.226562 370.359375 234.226562 L 211.582031 234.226562 C 206.613281 234.226562 202.582031 230.195312 202.582031 225.226562 L 202.582031 124.34375 C 202.582031 119.371094 206.613281 115.34375 211.582031 115.34375 Z M 211.582031 115.34375 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "30709cfb85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.640625 246.453125 L 181.570312 246.453125 L 181.570312 365.335938 L 4.640625 365.335938 Z M 4.640625 246.453125 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c5c20e0a26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.640625 246.453125 L 172.417969 246.453125 C 177.386719 246.453125 181.417969 250.484375 181.417969 255.453125 L 181.417969 356.335938 C 181.417969 361.304688 177.386719 365.335938 172.417969 365.335938 L 13.640625 365.335938 C 8.671875 365.335938 4.640625 361.304688 4.640625 356.335938 L 4.640625 255.453125 C 4.640625 250.484375 8.671875 246.453125 13.640625 246.453125 Z M 13.640625 246.453125 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3814af863d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 202.582031 246.453125 L 379.511719 246.453125 L 379.511719 365.335938 L 202.582031 365.335938 Z M 202.582031 246.453125 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03a594912e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211.582031 246.453125 L 370.359375 246.453125 C 375.328125 246.453125 379.359375 250.484375 379.359375 255.453125 L 379.359375 356.335938 C 379.359375 361.304688 375.328125 365.335938 370.359375 365.335938 L 211.582031 365.335938 C 206.613281 365.335938 202.582031 361.304688 202.582031 356.335938 L 202.582031 255.453125 C 202.582031 250.484375 206.613281 246.453125 211.582031 246.453125 Z M 211.582031 246.453125 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8d1e3e65a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.640625 18.664062 L 379.433594 18.664062 L 379.433594 89.109375 L 4.640625 89.109375 Z M 4.640625 18.664062 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5900869c74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.140625 18.664062 L 365.859375 18.664062 C 369.4375 18.664062 372.875 20.085938 375.40625 22.617188 C 377.9375 25.148438 379.359375 28.582031 379.359375 32.164062 L 379.359375 75.609375 C 379.359375 79.191406 377.9375 82.625 375.40625 85.15625 C 372.875 87.6875 369.4375 89.109375 365.859375 89.109375 L 18.140625 89.109375 C 14.5625 89.109375 11.125 87.6875 8.59375 85.15625 C 6.0625 82.625 4.640625 79.191406 4.640625 75.609375 L 4.640625 32.164062 C 4.640625 28.582031 6.0625 25.148438 8.59375 22.617188 C 11.125 20.085938 14.5625 18.664062 18.140625 18.664062 Z M 18.140625 18.664062 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "9552a2e49f"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#f539359b37)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#2e084e6123)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#241f45",
      fillOpacity: 1
    },
    d: "M 4.640625 115.34375 L 181.570312 115.34375 L 181.570312 234.226562 L 4.640625 234.226562 Z M 4.640625 115.34375 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#a5eb9378c1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#5139a81386)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#241f45",
      fillOpacity: 1
    },
    d: "M 202.582031 115.34375 L 379.511719 115.34375 L 379.511719 234.226562 L 202.582031 234.226562 Z M 202.582031 115.34375 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#30709cfb85)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#c5c20e0a26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#241f45",
      fillOpacity: 1
    },
    d: "M 4.640625 246.453125 L 181.570312 246.453125 L 181.570312 365.335938 L 4.640625 365.335938 Z M 4.640625 246.453125 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#3814af863d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#03a594912e)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#241f45",
      fillOpacity: 1
    },
    d: "M 202.582031 246.453125 L 379.511719 246.453125 L 379.511719 365.335938 L 202.582031 365.335938 Z M 202.582031 246.453125 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#8d1e3e65a4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#5900869c74)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#241f45",
      fillOpacity: 1
    },
    d: "M 4.640625 18.664062 L 379.433594 18.664062 L 379.433594 89.109375 L 4.640625 89.109375 Z M 4.640625 18.664062 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArShadesCataloguesicon);
export default __webpack_public_path__ + "static/media/ARShades Catalogues icon.5e1fcf4c80c6e9dc9d2b4ea19c167638.svg";
export { ForwardRef as ReactComponent };